import React, { useEffect, useState, useRef } from "react";
import { getDepartmentAvailableSlots } from "../Services/api";
import Loader from './Loader';
import { createSlotsWebSocket } from "../Services/api";
import { createPortal } from "react-dom";

export default function AvailableSlotsPopup({ open, onClose, slots, appointmentDate, doctorId, onSelectSlot }) {
  const [slotsLoc, setLocSlots] = useState([]);
  const wsRef = useRef(null);
  const initializedRef = useRef(false);
  useEffect(() => {
    if (!open) return;
    setLocSlots(slots);
  }, [slots, open]);



  useEffect(() => {
    if (!doctorId || !appointmentDate || !open) return;

    if (!wsRef.current) {
      wsRef.current = createSlotsWebSocket((data) => {
        console.log("📩 WS message:", data);

        setLocSlots((prev) => {
          // console.log("🟡 prev slots:", JSON.stringify(prev));

          const updated = prev.map((slot) => {
            if (slot.slotId === data.slotId) {
              console.log("🟢 MATCH FOUND:", slot.slotId);
              return { ...slot, available: false };
            }
            return slot;
          });

          console.log("🔵 updated slots:", JSON.stringify(updated));
          return updated;
        });
      });

    }

    return () => {
      wsRef.current?.close();
      wsRef.current = null;
    };
  }, [doctorId, appointmentDate, open]);





  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0  bg-black bg-opacity-50 backdrop-blur-sm flex justify-center items-center z-[9999] px-2 sm:px-0">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl w-full max-w-md sm:max-w-lg p-5 sm:p-6 relative flex flex-col max-h-[80vh] overflow-hidden transform transition-transform duration-300 scale-95 animate-popup-in">
        <div className="flex justify-between items-center border-b border-gray-200 dark:border-gray-600 pb-2 mb-4 flex-shrink-0">
          <h2 className="text-base sm:text-lg font-semibold text-gray-700 dark:text-gray-200">Available Slots</h2>
          <button
            onClick={() => onClose(false)}
            className="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 text-xl leading-none rounded-full w-7 h-7 flex items-center justify-center hover:bg-gray-100 dark:hover:bg-gray-700 transition"
          >✕</button>
        </div>

        <div className="flex-1 overflow-y-auto">
          {slotsLoc.length === 0 ? (
            <p className="text-center text-sm sm:text-base text-gray-500 dark:text-gray-400">
              No slots available
            </p>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 sm:gap-3">
              {slotsLoc.map((slot) => (
                <button
                  key={slot.slotId}
                  disabled={!slot.available}
                  title={slot.available ? "Available" : "Already booked"}
                  className={`rounded-md py-2 px-2 sm:px-3 text-xs sm:text-sm flex flex-col items-center transition-booked
  ${!slot.available
                      ? "bg-gray-300 dark:bg-gray-700 text-gray-500 cursor-not-allowed border border-gray-400 dark:border-gray-600"
                      : "bg-green-100 dark:bg-green-700 text-gray-800 dark:text-white hover:bg-green-200 dark:hover:bg-green-600 cursor-pointer border border-green-400"
                    }
`}

                  onClick={() => {
                    onSelectSlot({
                      appointmentDate,
                      startTime: slot.startTime,
                      endTime: slot.endTime,
                      slotId: slot.slotId,
                      available: slot.available,
                      period: slot.period,
                      consultationFee: slot.consultationFee,
                      shiftId: slot.shiftId,
                      tokenNumber: slot.tokenNumber,
                    });
                    onClose(false);
                  }}
                >
                  <span className="font-medium">{slot.startTime} - {slot.endTime}</span>
                  <span className="text-[10px] sm:text-xs text-gray-500 dark:text-gray-300">{slot.period === "morning" && "🌅"}
                    {slot.period === "afternoon" && "☀️"}
                    {slot.period === "evening" && "🌙"}
                    {slot.period}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}